import { atom, selectorFamily } from 'recoil';
import getVehicleExistence from 'api/obes/getIsRegisteredVehicleBeingMovedToNewAgreement';
export const isRegisteredVehicleBeingMovedRequestId = atom({
  key: 'isRegisteredVehicleBeingMovedRequestId',
  default: 0
});
const isRegisteredVehicleBeingMoved = selectorFamily({
  key: 'registeredVehicleIsBeingMoved',
  get: ({
    registrationNumber,
    nationality
  }) => async ({
    get
  }) => {
    get(isRegisteredVehicleBeingMovedRequestId);
    if (!registrationNumber || registrationNumber.length < 2) {
      return false;
    }
    const res = await getVehicleExistence(registrationNumber, nationality);
    return res;
  }
});
export default isRegisteredVehicleBeingMoved;